import { useEffect, useState } from 'react'

import { useStore } from '../../../../hooks/storeHook'
import { useToggleState } from '../../../../hooks/commonHooks'
import { useYmAccountOptional } from '../../../../hooks/routeHooks'

import { required } from '../../../../common/objectUtils'
import { UnprocessedValueError } from '../../../../common/tsUtils'

import { MoySkladAppType } from '../../../../server/mpsklad_common/MoySkladAppType'
import { UserAuthModel } from '../../../../server/mpsklad_core/Models/UserAuthModel'
import { YandexMarketDeliveryType } from '../../../../server/mpsklad_core/Entity/YandexMarket/Enums/YandexMarketDeliveryType'

export const useYandexMarketForm =
  () => {
    const store = useStore()

    const account = useYmAccountOptional()

    const [apiKey, setApiKey] = useState(account?.apiKey ?? '')
    const [isUsingNewApiKeyFormat, toggleIsUsingNewApiKeyFormat] =
      useToggleState(account?.isUsingNewApiKeyFormat ?? true)

    const [campaignId, setCampaignId] = useState(account?.campaignId.toString() ?? '')
    const [businessId, setBusinessId] = useState(account?.businessId.toString() ?? '')
    const [userCode, setUserCode] = useState('')

    const [name, setName] = useState(account?.name ?? 'Мой аккаунт')

    const [deliveryType, setDeliveryType] =
      useState(account?.deliveryType ?? getDefaultYmDeliveryType(required(store.user)))

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
      if (!isUsingNewApiKeyFormat && !account?.isUsingNewApiKeyFormat) {
        // Prevent showing the old format API token in the new format field if the user flips the switch from the old format to the new one
        setApiKey('')
      } else {
        setApiKey(account?.apiKey?.toString() ?? '')
      }
    }, [account?.apiKey, account?.isUsingNewApiKeyFormat, isUsingNewApiKeyFormat])

    return {
      account,
      apiKey,
      setApiKey,
      isUsingNewApiKeyFormat,
      toggleIsUsingNewApiKeyFormat,
      campaignId,
      setCampaignId,
      businessId,
      setBusinessId,
      userCode,
      setUserCode,
      name,
      setName,
      deliveryType,
      setDeliveryType,
      isLoading,
      setIsLoading
    } as const
  }

export const getDefaultYmDeliveryType =
  (user: UserAuthModel) => {
    switch (user.moySkladAppType) {
      case null:
      case undefined:
      case MoySkladAppType.Ym:
      case MoySkladAppType.OzonAndWb:
        return YandexMarketDeliveryType.FBS

      case MoySkladAppType.UzbYm:
        return YandexMarketDeliveryType.UzbFBS

      case MoySkladAppType.Ozon:
      case MoySkladAppType.Wb:
      case MoySkladAppType.Mini:
        throw new Error(`Bad MS app type: ${user.moySkladAppType}`)

      default:
        throw new UnprocessedValueError('MoySkladAppType', user.moySkladAppType)
    }
  }